export const serverLatencyMessage =
  'It can take up to 30 seconds for the changes to be reflected.';
